const smallAreas = [
  {
    name: `Brisbane - East`,
    icon: '/small-area-icons/Brisbane - East.svg',
  },
  {
    name: `Brisbane - North`,
    icon: '/small-area-icons/Brisbane - North.svg',
  },
  {
    name: `Brisbane - South`,
    icon: '/small-area-icons/Brisbane - South.svg',
  },
  {
    name: `Brisbane - West`,
    icon: '/small-area-icons/Brisbane - West.svg',
  },
  {
    name: `Brisbane Inner City`,
    icon: '/small-area-icons/Brisbane - Inner City.svg',
  },
  {
    name: `Moreton Bay - South`,
    icon: '/small-area-icons/Moreton Bay - South.svg',
  },
];

export default smallAreas;



// WEBPACK FOOTER //
// ./src/helpers/small-areas.js